import { render, staticRenderFns } from "./Actualites.vue?vue&type=template&id=ca244246&scoped=true"
import script from "./Actualites.vue?vue&type=script&lang=js"
export * from "./Actualites.vue?vue&type=script&lang=js"
import style0 from "./Actualites.vue?vue&type=style&index=0&id=ca244246&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca244246",
  null
  
)

export default component.exports